var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFnbHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61 31C61 14.4315 47.5685 1 31 1C14.4315 1 1 14.4315 1 31C1 47.5685 14.4315 61 31 61C47.5685 61 61 47.5685 61 31Z",
    fill: "white",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6109 43H39.4218C40.3382 43 41.0909 42.3015 41.2 41.4065L43 23.4202H37.5455V19H35.3964V23.4202H29.9745L30.3018 25.9741C32.1673 26.487 33.9127 27.4147 34.96 28.4407C36.5309 29.9904 37.6109 31.5948 37.6109 34.2142V43ZM19 41.9086V40.8281H35.3964V41.9086C35.3964 42.5089 34.9055 43 34.2945 43H20.1018C19.4909 43 19 42.5089 19 41.9086ZM35.3964 34.2688C35.3964 25.5375 19 25.5375 19 34.2688H35.3964ZM19.0218 36.4625H35.3855V38.6453H19.0218V36.4625Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFnbHomeIcon);
export default __webpack_public_path__ + "static/media/fnb-home-icon.2b5933fe8274d3b1d2b5561a9b55cb17.svg";
export { ForwardRef as ReactComponent };